<template>
  <div class="wrapper" :class="item.css_class">
    <div class="buttons" v-if="parseInt(fairConfig.FC_ONDEMAND)">
      <div class="live" :class="{ selected: isLive }" @click="isLive = true">
        {{ $t('conferenceRoom.video.live') }} 
        <div class="red-dot"></div>
      </div>
      <div class="on-demand" :class="{ selected: !isLive }" @click="isLive = false">
        {{ $t('conferenceRoom.video.onDemand') }}
      </div>
    </div>
    <iframe
      v-if="isLive"
      :class="{ 'pervent-click': isChatOpen }"
      :src="item.link"
      frameborder="0"
      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen
    ></iframe>
    <div class="on-demand-wrapper"
      v-else
      ref="on-demand-wrapper"
    >
      <div class="each-embed-wrapper"
        v-for="(embed, index) in embeds"
        :key="index"
      > 
        <div class="embed-number">{{ index + 1 }}</div>
        <iframe
          :class="{ 'pervent-click': isChatOpen }"
          :src="embed.stl_link"
          frameborder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
        <div class="info" v-if="embed.stl_title || embed.stl_lecturer || embed.stl_duration">
          <span v-if="embed.stl_title" class="title">{{ embed.stl_title }}</span>
          <span v-if="embed.stl_lecturer" class="lecturer">{{ embed.stl_lecturer + " " }}</span>
          <span v-if="embed.stl_duration" class="lecturer"><strong>{{ $t('conferenceRoom.video.duration.label') }}</strong>{{ ": " + formatedDuration(embed.stl_duration) }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import { mapState } from 'vuex'
export default {
  props: {
    item: Object
  },
  data () {
    return {
      isLive: true,
      embeds: []
    }
  },
  computed: {
    ...mapState(["fairConfig"])
  },
  watch: {
    isLive: {
      handler (isTrue) {
        if (!isTrue) this.getEmbeds();
      }
    }
  },
  mounted () {
    this.getEmbeds();
  },
  methods: {
    async getEmbeds () {
      let apiObj = {
        api: api.getEmbeds,
        params: {
          loc_id: parseInt(this.$route.params.id)
        },
        onError: this.stopLoading
      }
      this.startLoading();
        const data = await this.apiCall(apiObj);
        if (data && data.ondemand) this.embeds = data.ondemand;
      this.stopLoading();
    },
    formatedDuration (duration) {
      if (duration) {
        let returnString = "";
        let durationParts = duration.split(':');
        if (parseInt(durationParts[0]) > 1) {
          returnString += `${parseInt(durationParts[0])} ${this.$t('conferenceRoom.video.duration.hours')} `;
        } else {
          returnString += `${parseInt(durationParts[0])} ${this.$t('conferenceRoom.video.duration.hour')} `;
        }
  
        if (parseInt(durationParts[1]) > 1) {
          returnString += `${parseInt(durationParts[1])} ${this.$t('conferenceRoom.video.duration.minutes')}`;
        } else {
          returnString += `${parseInt(durationParts[1])} ${this.$t('conferenceRoom.video.duration.minute')}`;
        }
  
        return returnString;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
.wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  iframe, .on-demand-wrapper {
    height: 100%;
    width: 100%;
  }
  .on-demand-wrapper {
    display: flex;
    flex-wrap: wrap;
    background-color: #C4C4C4;
    overflow: auto;
    padding-bottom: 20px;
    cursor: default;
    .each-embed-wrapper {
      display: flex;
      flex-direction: column;
      // justify-content: flex-end;
      align-items: flex-end;
      position: relative;
      width: 380px;
      height: 300px;
      margin: 0 10px 25px 10px;
      padding-top: 50px;
      .embed-number {
        position: absolute;
        line-height: 9vw;
        font-size: 10vw;
        font-weight: 900;
        top: 0px;
        left: 15px;
        color: #ECECEC;
        pointer-events: none;
      }
      iframe {
        z-index: 1;
        min-width: 83%;
        min-height: 77%;
        max-width: 83%;
        max-height: 77%;
      }
      .info {
        width: 83%;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        background: white;
        padding: 10px;
        > * {
          margin: 3px 0;
        }
        word-break: break-word;
        .title {
          color: #353535;
          font-size: 12px;
          font-weight: 700;
        }
        .lecturer {
          color: #646464;
          font-size: 9px;
          font-weight: 400;
        }
      }
    }
  }
}
.buttons {
  * {
    box-sizing: border-box;
  }
  display: flex;
  width: 45%;
  font-size: 1.2vw;
  font-weight: 900;
  color: white;
  user-select: none;
  position: absolute;
  height: 60px;
  top: -60px;
  .live {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    padding: 2% 3%;
    flex-basis: 45%;
    background-color: #D64545;
    border-bottom: 3px solid transparent;
    text-transform: uppercase;
    .red-dot {
      width: 0.8vw;
      height: 0.8vw;
      border-radius: 50%;
      background-color: #ED0000;
      border: 1px solid white;
    }
  }
  .on-demand {
    display: flex;
    align-items: center;
    padding: 2% 3%;
    flex-basis: 55%;
    background-color: #EBA900;
    border-bottom: 3px solid transparent;
    text-transform: uppercase
  }
  .selected {
    box-shadow: inset 0px 4px 4px rgba(0, 0, 0, 0.25);
    border-bottom: 3px solid white;
  }
}

@media (max-width: 900px) {
  .buttons {
    font-size: 1.5vw;
  }
  .wrapper {
    .on-demand-wrapper {
      .each-embed-wrapper {
        .embed-number {
          line-height: 15vw;
          font-size: 16vw;
        }
      }
    }
  }
}

@media (max-width: 600px) {
  .buttons {
    font-size: 2.5vw;
    height: 40px;
    top: -40px;
  }
  .wrapper {
    .on-demand-wrapper {
      .each-embed-wrapper {
        .embed-number {
          line-height: 25vw;
          font-size: 26vw;
        }
      }
    }
  }
}

@media (max-width: 360px) {
  .buttons {
    font-size: 3.5vw;
  }
  .wrapper {
    .on-demand-wrapper {
      .each-embed-wrapper {
        .embed-number {
          line-height: 45vw;
          font-size: 46vw;
        }
      }
    }
  }
}
</style>